/* AMTENDENCY — mantém a barra fixa de compra em dia na troca de variante.

   O `product-info.js` do Dawn re-renderiza a PDP por id: `price-{section}`,
   `Sku-{section}`, `Inventory-{section}` e mais alguns. A barra fixa do celular
   é um bloco `custom_liquid`, não tem esse id, e ficava mostrando o preço da
   PRIMEIRA variante mesmo depois de trocar.

   O arquivo já cuidou também de Pix e parcelamento; esses blocos saíram da
   página (a referência não os tem) e o código deles foi removido junto.

   Cuidado que custou um bug silencioso: o alvo é a CLASSE `.am-stickyatc__price`
   que o `am-sticky-atc.liquid` emite — não existe atributo `data-*` ali. */
(function () {
  function atualiza() {
    var barra = document.querySelector('.am-stickyatc__price');
    if (!barra) return;
    // o preço da coluna já foi trocado pelo Dawn quando este evento chega
    var preco = document.querySelector('.product__info-container .price .price-item');
    if (preco) barra.textContent = preco.textContent.trim();
  }

  function liga() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return false;
    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      // o texto novo entra no mesmo tique em que o Dawn troca o markup do preço
      requestAnimationFrame(atualiza);
    });
    return true;
  }

  // o pubsub.js e o constants.js entram com defer, como este arquivo;
  // se ainda não estiverem prontos, tenta de novo no load
  if (!liga()) window.addEventListener('load', liga);
})();
